"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snippetOf = exports.readBookmarkedParagraphText = exports.UNAVAILABLE_PARAGRAPH_PHRASE = exports.ProposalCardContextLine = exports.CommentAnchorContext = void 0;
exports.useContextTextReading = useContextTextReading;
var _react = _interopRequireWildcard(require("react"));
var _wordTokenizer = require("@common/utils/redline/text/word-tokenizer");
var _document = require("../../../utils/document");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var SNIPPET_WORDS = 14;
var WORD_READ_ATTEMPTS = 3;
var WORD_READ_RETRY_MS = 800;
var UNAVAILABLE_PARAGRAPH_PHRASE = exports.UNAVAILABLE_PARAGRAPH_PHRASE = "a paragraph that is no longer in the document";
var snippetOf = exports.snippetOf = function snippetOf(text) {
  var words = _wordTokenizer.WordTokenizer.words(text);
  return words.length > SNIPPET_WORDS ? "".concat(words.slice(0, SNIPPET_WORDS).join(" "), "\u2026") : words.join(" ");
};
var readBookmarkedParagraphText = exports.readBookmarkedParagraphText = function readBookmarkedParagraphText(bookmark) {
  return (0, _document.withWordContextRead)(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(context) {
      var paragraph;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            paragraph = context.document.getBookmarkRangeOrNullObject(bookmark).paragraphs.getFirstOrNullObject();
            paragraph.load("text");
            _context.n = 1;
            return context.sync();
          case 1:
            return _context.a(2, paragraph.isNullObject ? null : paragraph.text);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};
function useContextTextReading(knownText, readKey, readText) {
  var _useState = (0, _react.useState)({
      kind: "loading"
    }),
    _useState2 = _slicedToArray(_useState, 2),
    readReading = _useState2[0],
    setReadReading = _useState2[1];
  (0, _react.useEffect)(function () {
    if (knownText !== null || readKey === null) return;
    var cancelled = false;
    var retryTimeoutId;
    setReadReading({
      kind: "loading"
    });
    var _attemptRead = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(attemptsLeft) {
        var text, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return readText(readKey);
            case 1:
              text = _context2.v;
              if (!cancelled) setReadReading(text === null ? {
                kind: "unavailable"
              } : {
                kind: "known",
                text: text
              });
              _context2.n = 5;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              if (!cancelled) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              if (!(attemptsLeft <= 1)) {
                _context2.n = 4;
                break;
              }
              setReadReading({
                kind: "unavailable"
              });
              return _context2.a(2);
            case 4:
              retryTimeoutId = window.setTimeout(function () {
                return void _attemptRead(attemptsLeft - 1);
              }, WORD_READ_RETRY_MS);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function attemptRead(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    void _attemptRead(WORD_READ_ATTEMPTS);
    return function () {
      cancelled = true;
      window.clearTimeout(retryTimeoutId);
    };
  }, [knownText, readKey, readText]);
  if (knownText !== null) return {
    kind: "known",
    text: knownText
  };
  if (readKey === null) return {
    kind: "unavailable"
  };
  return readReading;
}
var ProposalCardContextLine = exports.ProposalCardContextLine = function ProposalCardContextLine(_ref3) {
  var lead = _ref3.lead,
    reading = _ref3.reading,
    unavailablePhrase = _ref3.unavailablePhrase;
  function renderSubject() {
    if (reading.kind === "loading") {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        "aria-label": "Loading",
        className: "inline-block h-[10px] w-40 max-w-[60%] rounded-sm bg-[#E5E2DD] animate-pulse align-middle"
      });
    }
    if (reading.kind === "unavailable") return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: unavailablePhrase
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[#4a5568] bg-[#FFF7E0] rounded px-0.5",
      "data-sentry-component": "renderSubject",
      "data-sentry-source-file": "CommentAnchorContext.tsx",
      children: "\"".concat(snippetOf(reading.text), "\"")
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "text-[11px] leading-[16px] text-[#686766]",
    "data-sentry-component": "ProposalCardContextLine",
    "data-sentry-source-file": "CommentAnchorContext.tsx",
    children: [lead, " ", renderSubject()]
  });
};
var CommentAnchorContext = exports.CommentAnchorContext = function CommentAnchorContext(_ref4) {
  var _bookmarks$;
  var bookmarks = _ref4.bookmarks,
    anchorText = _ref4.anchorText,
    placement = _ref4.placement,
    paragraphText = _ref4.paragraphText;
  var knownText = anchorText || paragraphText || null;
  var reading = useContextTextReading(knownText, (_bookmarks$ = bookmarks[0]) !== null && _bookmarks$ !== void 0 ? _bookmarks$ : null, readBookmarkedParagraphText);
  var lead = placement === "after_paragraph" ? "On the paragraph after" : "On";
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProposalCardContextLine, {
    lead: lead,
    reading: reading,
    unavailablePhrase: UNAVAILABLE_PARAGRAPH_PHRASE,
    "data-sentry-element": "ProposalCardContextLine",
    "data-sentry-component": "CommentAnchorContext",
    "data-sentry-source-file": "CommentAnchorContext.tsx"
  });
};